import React from "react";
import { BsGear, BsFunnel, BsX } from "react-icons/bs";
import VepForm from "../forms/VepForm";
import { FiltersForm } from "../filtering/components";
import DiseasesModal from "../modals/DiseasesModal";
import PanelsModal from "../modals/PanelsModal";
import hierarchy from "../../configs/hierarchy.json";

const SidebarPanel = ({
  token,
  showAnnotator,
  vepDynamic,
  setVepDynamic,
  Vep_params,
  setVepParams,
  filterData,
  setFilterData,
  filters,
  setFilters,
  addFilter,
  showModal,
  setShowModal,
  showPanel,
  setShowPanel,
  selectedDiseases,
  setSelectedDiseases,
  confidence_score,
  setConfidenceScore,
  DiseaseDatasets,
  setDiseaseDatasets,
  selectedPanels,
  setSelectedPanels,
  rowIndex,
  showBuilder,
  handleFormToggle,
  sidebarVisible,
  isMobile,
  toggleSidebar,
  filter_results,
  gridRef,
  attributeFilterString,
  setAttributeFilterString,
}) => {
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const handlePanelShow = () => setShowPanel(true);
  const handlePanelClose = () => setShowPanel(false);

  if (!sidebarVisible) {
    return null;
  }

  return (
    <div
      className="sidebar-panel-content"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div
        className="sticky-top pt-3"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        {/* Sidebar Header */}
        <div className="px-2 mb-1" style={{ flexShrink: 0 }}>
          {/* Button Navigation with Mobile Close */}
          <div className="d-flex gap-1 mb-1 align-items-center">
            <button
              className={`btn btn-sm btn-animate d-flex align-items-center gap-1 justify-content-center flex-fill ${
                showAnnotator ? "btn-primary" : "btn-outline-secondary"
              }`}
              onClick={() => handleFormToggle("dynamic")}
              type="button"
              role="tab"
              aria-selected={showAnnotator}
            >
              <BsGear />
              <span className="fw-medium">VEP</span>
            </button>
            <button
              className={`btn btn-sm btn-animate d-flex align-items-center gap-1 justify-content-center flex-fill ${
                !showAnnotator ? "btn-primary" : "btn-outline-secondary"
              }`}
              onClick={() => handleFormToggle("vep")}
              type="button"
              role="tab"
              aria-selected={!showAnnotator}
            >
              <BsFunnel />
              <span className="fw-medium">Filter</span>
            </button>
            {/* Mobile close button integrated with navigation */}
            {isMobile && (
              <button
                className="btn btn-sm btn-outline-secondary btn-animate d-flex align-items-center justify-content-center"
                style={{
                  padding: "4px 8px",
                  minWidth: "32px",
                }}
                onClick={() => toggleSidebar && toggleSidebar()}
                aria-label="Close sidebar"
              >
                <BsX size={20} />
              </button>
            )}
          </div>
        </div>

        {/* Scrollable Content Container */}
        <div className="sidebar-content-container flex-grow-1">
          <div className="px-2">
            {showAnnotator ? (
              <div>
                {/* Dynamic VEP Toggle */}
                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-body py-3">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <label
                          className="fw-semibold mb-0"
                          htmlFor="flexSwitchCheckDefault"
                        >
                          Dynamic VEP
                        </label>
                        <small className="d-block text-muted mt-1">
                          Enable real-time annotation
                        </small>
                      </div>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                          checked={vepDynamic}
                          onChange={() => setVepDynamic(!vepDynamic)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* VEP Form */}
                <VepForm
                  parentData={Vep_params}
                  onParentDataChange={setVepParams}
                  token={token}
                />
              </div>
            ) : (
              <div>
                {/* Filters Form */}
                <FiltersForm
                  filterData={filterData}
                  setFilterData={setFilterData}
                  filters={filters}
                  setFilters={setFilters}
                  addFilter={addFilter}
                  handleShow={handleShow}
                  handlePanelShow={handlePanelShow}
                  filter_results={filter_results}
                  showBuilder={showBuilder}
                  gridRef={gridRef}
                  attributeFilterString={attributeFilterString}
                  setAttributeFilterString={setAttributeFilterString}
                />

                {/* Hidden container for attribute filter */}
                <div id="advancedFilterParent" className="d-none"></div>
              </div>
            )}
          </div>
        </div>

        {/* Modals */}
        <DiseasesModal
          showModal={showModal}
          handleClose={handleClose}
          hierarchy={hierarchy}
          selectedDiseases={selectedDiseases}
          setSelectedDiseases={setSelectedDiseases}
          confidence_score={confidence_score}
          setConfidenceScore={setConfidenceScore}
          DiseaseDatasets={DiseaseDatasets}
          setDiseaseDatasets={setDiseaseDatasets}
          filterData={filterData}
          setFilterData={setFilterData}
          token={token}
        />
        <PanelsModal
          showModal={showPanel}
          handleClose={handlePanelClose}
          selectedPanels={selectedPanels}
          setSelectedPanels={setSelectedPanels}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      </div>
    </div>
  );
};

export default SidebarPanel;
